import { qualifyUrls } from "routing/Routes";
const AgentWorkflowRoutes = {
  WORKFLOWS: "/agent-workflows",
  workflowDetails: (id) => `/agent-workflows/${id}`,
  RUNS: "/agent-workflow/runs",
  runDetails: (id) => `/agent-workflow/runs/${id}`,
  USAGE: "/agent-workflow/usage",
  SETTINGS: "/agent-workflow/settings"
};
const routes = qualifyUrls(AgentWorkflowRoutes);
export default {
  ...routes,
  unqualified: AgentWorkflowRoutes
};
